// @ts-nocheck
import { useEffect } from 'react';
import { omit } from 'lodash';
import { useStore } from '@hmpu/powerups.store';
import {
  OptionsMenuListItem,
  ListItemPropsOptions,
} from '../../OptionsMenuListItem';
import type { OptionsMenuListItems } from '../../useSettingsConfig';

export type OptionsMenuProps = {
  items: OptionsMenuListItems;
  options: Partial<ListItemPropsOptions>;
};

function OptionsMenu({ items, options }: OptionsMenuProps) {
  const { __t } = options;

  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const setPageTitle = useStore((state) => state.setPageTitle);
  const pageTitle = __t('pageTitle');
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  const inPortrait = useStore((state) => state.inPortrait);
  useEffect(() => {
    setPageTitle(pageTitle);
  }, [showSettingsPanel, inPortrait, isPauseEnabled]);

  return (
    <section className="SettingsPanel-Container">
      <h1>{__t('optionsMenu')}</h1>
      <ul>
        {items
          .filter(
            (item) =>
              item.name !== 'OptionsMenu' &&
              item.shouldRender({ ...item, options })
          )
          .map((item) => omit(item, 'shouldRender'))
          .map((item) => (
            <OptionsMenuListItem key={item.name} {...item} options={options}>
              {__t(item.heading)}
            </OptionsMenuListItem>
          ))}
      </ul>
    </section>
  );
}

export default OptionsMenu;

